module.exports = __webpack_public_path__ + "static/kudigo-logo-e558ba6b9d7d5135e76e823181d77ec4.png";